import ScreenshotViewer from './ScreenshotViewer'
import { useState } from 'react'
import { projectDataApi, useGetSessionScreenshotQuery } from '../services/projectDataApi'

function ReplayFrame({ runId, observationId }: { runId: string; observationId: string }) {
  const args = { runId, observationId }
  const cached = projectDataApi.endpoints.getSessionScreenshot.useQueryState(args)
  const query = useGetSessionScreenshotQuery(args, {
    pollingInterval: cached.error || (cached.data && cached.data.status !== 'pending') ? 0 : 5000,
    skipPollingIfUnfocused: true,
  })
  const [imageFailed, setImageFailed] = useState(false)
  if (query.error || imageFailed || query.data?.status === 'unavailable') {
    return <p className="user-session-detail__unavailable">The Replay screenshot is unavailable for this comparison.</p>
  }
  if (!query.data || query.data.status === 'pending') {
    return <p role="status">Preparing Replay screenshot…</p>
  }
  const { screenshot } = query.data
  return <>
    <ScreenshotViewer frame={screenshot.url} alt="Journey page at the comparison observation" onError={() => setImageFailed(true)} />
    <p>Replay frame at {(screenshot.frame_timestamp / 1000).toFixed(2)}s</p>
  </>
}

export default function SessionComparisonScreenshot({ runId, recordingId, observationId }: {
  runId: string; recordingId: string | null; observationId?: string;
}) {
  if (!recordingId) return <p className="user-session-detail__unavailable">No Replay recording is available for this run.</p>
  if (!observationId) return <p className="user-session-detail__unavailable">This run has no comparison screenshot marker. Rerun the journey to capture comparison screenshots.</p>
  return <ReplayFrame runId={runId} observationId={observationId} />
}
